/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {AnimaFadeinTop} from '../../../../_metronic/assets/animation/styles'
import {RolesWrapper} from './pages/lista/RolesWrapper'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'

const RolesPage: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'ROLES.TITLE'})}</PageTitle>
      <AnimaFadeinTop>
        <div className='tab-content' id='myTabContent'>
          <div className='tab-pane fade active show' id='kt_tab_pane_1' role='tabpanel'>
            <RolesWrapper />
          </div>
          <div className='tab-pane fade' id='kt_tab_pane_2' role='tabpanel'></div>
        </div>
      </AnimaFadeinTop>
    </>
  )
}

export {RolesPage}